import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {declineReasons} from '/redux/selector/candidate.selector';

import DeclineReasonPopover from './DeclineReasonPopover';

export default connect(
  createStructuredSelector({
    declineReasonCodes: declineReasons,
  }),
)(DeclineReasonPopover);
